'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _Close = require('./Close');

var _Close2 = _interopRequireDefault(_Close);

var _Categories = require('./Categories');

var _Categories2 = _interopRequireDefault(_Categories);

var _Content = require('./Content');

var _Content2 = _interopRequireDefault(_Content);

var _selectors = require('../selectors');

var _config = require('config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStyle = function getStyle(isPage, maxHeight) {
  if (_config.CLIENT && isPage) {
    return {
      maxHeight: maxHeight
    };
  }

  return {};
};

var CLASS_NAME = 'matcher';

var Matcher = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Matcher, _Component);

  function Matcher(props) {
    (0, _classCallCheck3.default)(this, Matcher);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Matcher.__proto__ || (0, _getPrototypeOf2.default)(Matcher)).call(this, props));

    _this.state = {
      maxHeight: 0
    };
    _this.updateDimensions = _this.updateDimensions.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Matcher, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.updateDimensions);
      this.updateDimensions();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
    }
  }, {
    key: 'updateDimensions',
    value: function updateDimensions() {
      this.setState({
        maxHeight: window.innerHeight - 86
      });
    }
  }, {
    key: 'getNextCategory',
    value: function getNextCategory() {
      for (var i = 0; i < this.props.categories.length; i++) {
        if (this.props.categories[i].id === this.props.currentCategory && this.props.categories[i + 1]) {
          return this.props.categories[i + 1].id;
        }
      }
      return null;
    }
  }, {
    key: 'scrollTop',
    value: function scrollTop() {
      var matcherEl = document.getElementById('matcher');
      var bodyEl = document.body;
      if (matcherEl) {
        matcherEl.scrollTop = 0;
        bodyEl.scrollTop = bodyEl.scrollTop + matcherEl.getBoundingClientRect().top - 86;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          currentCategory = _props.currentCategory,
          handleClose = _props.handleClose,
          actions = _props.actions,
          interests = _props.interests,
          skills = _props.skills,
          educationLevels = _props.educationLevels,
          categories = _props.categories,
          sectionLabels = _props.sectionLabels,
          jobs = _props.jobs,
          loadingJobs = _props.loadingJobs,
          page = _props.page,
          jobLimit = _props.jobLimit;


      var style = getStyle(page, this.state.maxHeight);
      var nextCat = this.getNextCategory.call(this);

      return _react2.default.createElement(
        'article',
        {
          id: CLASS_NAME,
          style: (0, _extends3.default)({}, style)
        },
        _react2.default.createElement(
          'div',
          { className: CLASS_NAME },
          _react2.default.createElement(_Close2.default, {
            handleClick: handleClose
          }),
          _react2.default.createElement(_Categories2.default, {
            currentCategory: currentCategory,
            handleClick: actions.changeCategory,
            categories: categories
          }),
          _react2.default.createElement(_Content2.default, {
            currentCategory: currentCategory,
            interests: interests,
            skills: skills,
            educationLevels: educationLevels,
            changeInterestValue: actions.changeInterestValue,
            changeSkill: actions.changeSkill,
            changeEducation: actions.changeEducation,
            changeCategory: actions.changeCategory,
            sectionLabels: sectionLabels,
            jobs: jobs,
            loadingJobs: loadingJobs,
            jobLimit: jobLimit
          })
        ),
        currentCategory !== 'matches' ? _react2.default.createElement(
          'div',
          { className: 'next-hold' },
          _react2.default.createElement(
            'div',
            { className: 'next-category',
              onClick: function onClick() {
                actions.changeCategory(nextCat);
                _this2.scrollTop.call(_this2);
              } },
            'Continue to ',
            nextCat
          )
        ) : null
      );
    }
  }]);
  return Matcher;
}(_react.Component), _class.propTypes = {
  currentCategory: _react.PropTypes.string,
  handleClose: _react.PropTypes.func,
  actions: _react.PropTypes.object,
  interests: _react.PropTypes.array,
  skills: _react.PropTypes.array,
  educationLevels: _react.PropTypes.array,
  categories: _react.PropTypes.array,
  sectionLabels: _react.PropTypes.any,
  jobs: _react.PropTypes.any,
  loadingJobs: _react.PropTypes.any,
  page: _react.PropTypes.any,
  jobLimit: _react.PropTypes.number
}, _temp);
exports.default = (0, _reactRedux.connect)(_selectors.mapStateToProps, _selectors.mapDispatchToProps)(Matcher);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Matcher/components/Matcher.jsx
// module id = 1237
// module chunks = 0